import { Card, Typography } from '@mui/material';

const PatternCard = ({ patternId, pattern, onClick }) => {
  return (
    <Card
      variant="outlined"
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        '&:hover': { boxShadow: 1 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        p: 2
      }}
    >
      <Typography variant="h6" sx={{ textAlign: 'center' }}>
        {pattern.name}
      </Typography>
      <Typography variant="body2" sx={{ textAlign: 'center' }}>
        {patternId}
      </Typography>
    </Card>
  );
};

export default PatternCard;
